// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/beastSearch-" + chunkId + "." + {"1":"5483bea3","2":"ed54204d","3":"0b50d2e8","4":"7350103f"}[chunkId] + ".min.js";
};